import * as React from 'react';

import { cn } from '@/lib/utils';

type TextAreaProps = React.ComponentProps<'textarea'> & {
  error?: string;
};

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, error, id, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex w-full min-h-12 text-foreground rounded-lg border border-border-strong focus-visible:border-accent bg-surface px-3 py-2 shadow-sm placeholder:text-sm placeholder:text-foreground-muted focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          className,
          error && 'border-danger-8 focus-visible:border-danger-8'
        )}
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error && id ? `${id}-error` : undefined}
        ref={ref}
        {...props}
      />
    );
  }
);
TextArea.displayName = 'TextArea';

export default TextArea;
